/*document.addEventListener('DOMContentLoaded', (event) => {
    // Get the clickable element
    const ratingsElement = document.querySelector('.product-ratings');
    
    // Check if the clickable element exists
    if (ratingsElement) {
        // Set up a click event listener
        ratingsElement.addEventListener('click', () => {
            const summaryElement = document.querySelector('.stamped-summary');
            if (summaryElement) {
                // Calculate the position to scroll to, 20px above the element
                const offset = 20; // offset in pixels above the target
                const elementPosition = summaryElement.getBoundingClientRect().top + window.pageYOffset - offset;

                // Scroll to the calculated position smoothly
                window.scrollTo({
                    top: elementPosition,
                    behavior: 'smooth'
                });
            } else {
                console.log("Element with class 'stamped-summary' not found.");
            }
        });
    } else {
        console.log("Element with class 'product-ratings' not found.");
    }
});
*/

//let observer; // Global reference to the observer

function scrollToSummary() {
    const summaryElement = document.querySelector('.stamped-summary');
    if (summaryElement) {
        const offset = 20; // Offset in pixels above the target
        const elementPosition = summaryElement.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
        });
    } else {
        console.log("Element with class 'stamped-summary' not found.");
    }
}

function setupObserver() {
    observer = new MutationObserver((mutations) => {
        // Perform the scroll adjustment
        scrollToSummary();
    });

    // Observer configuration, watching for nodes being added or removed
    const config = {
        childList: true,
        subtree: true
    };

    // Activate the observer
    observer.observe(document.body, config);

    // Set a timer to disconnect the observer after a certain time period
    setTimeout(() => {
        if (observer) {
            observer.disconnect();
        }
    }, 1500); // Adjust this timeout to match the expected lazy loading time
}

document.addEventListener('DOMContentLoaded', () => {
    const ratingsElement = document.querySelector('.product-ratings');
    if (ratingsElement) {
        ratingsElement.addEventListener('click', () => {
            setupObserver(); // Set up observer on click
            scrollToSummary(); // Perform an immediate scroll
        });
    } else {
        //console.log("Element with class 'product-ratings' not found.");
    }
});